"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var sortJson_exports = {};
__export(sortJson_exports, {
  sortJson: () => sortJson
});
module.exports = __toCommonJS(sortJson_exports);
const defaultInitialKeys = ["type", "id"];
function compareFunc(initialKeys) {
  if (initialKeys == null) {
    return void 0;
  } else {
    return (a, b) => {
      const i = initialKeys.indexOf(a);
      const j = initialKeys.indexOf(b);
      if (i >= 0) {
        if (j >= 0) {
          return i - j;
        } else {
          return -1;
        }
      } else {
        if (j >= 0) {
          return 1;
        } else {
          return a < b ? -1 : 1;
        }
      }
    };
  }
}
function sortJson(value, options = {}) {
  const { initialKeys = defaultInitialKeys } = options;
  if (Array.isArray(value)) {
    return value.map((value2) => sortJson(value2, options));
  } else if (typeof value === "object" && value != null) {
    const ans = {};
    const keys = Object.keys(value).sort(compareFunc(initialKeys));
    for (const key of keys) {
      ans[key] = sortJson(value[key], options);
    }
    return ans;
  } else {
    return value;
  }
}
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  sortJson
});
//# sourceMappingURL=sortJson.js.map
